import { render, staticRenderFns } from "./PowerWriterRight.vue?vue&type=template&id=4035d340&scoped=true"
import script from "./PowerWriterRight.vue?vue&type=script&lang=js"
export * from "./PowerWriterRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035d340",
  null
  
)

export default component.exports